import * as React from "react";
import { Alert } from "antd";
import { useCpFormError } from "./utils";

export function CpRootError() {
  const error = useCpFormError("root");

  if (!error) {
    return null;
  }

  return <Alert className="mb-4" type="error" showIcon message="Validation Error" description={error} />;
}
